export type LockReservationSubtype = "B2BlockReservationSubtype" | "B2ClockReservationSubtype";

export const getLockServicePath = (hubMetaName: string, subtype: LockReservationSubtype) =>
	subtype === "B2ClockReservationSubtype" ? `/${hubMetaName}/lock` : `/${hubMetaName}/swap`;

export const appendSearch = (pathname: string, search: string) => `${pathname}${search}`;
